import React from 'react';

const AvatarTooltip = ({ children, content }) => {
  return (
    <div className="avatar-tooltip-wrapper" data-tooltip={content}>
      {children}
    </div>
  );
};

export default AvatarTooltip;